var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn rounded-0 text-uppercase d-flex flex-column text-muted justify-content-center",on:{"click":_vm.show}},[_c('i',{staticClass:"fas fa-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.__("auction.search_bar")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }